import classes from "./authLayout.module.css";
import { Logo } from "../../constants";
import { Outlet } from "react-router-dom";
import BlueBgLogo from "../../assets/svgs/blueLogo.svg";

const AuthLayout = () => {
  return (
    <main className={`relative ${classes.container}`}>
      <div className={classes.textContent}>
        <div className={classes.banner}>
          <Logo color={"#ffffff"} />
        </div>
        <h2 className="lg:text-5xl text-3xl font-semibold mt-6 mb-4">The Perfect Match</h2>
        <p className="lg:text-xl text-base font-light mb-10">
          Bridging the gap between companies and exceptional professionals —
          verified and ready to hire.
        </p>
      </div>
      <div>
        <div className={`mt-md ${classes.logo} `}>
          <div className={`${classes.logoContainer}`}>
            <Logo color={"#030659"} />
          </div>
          <div className={`${classes.blueBgLogo}`}>
            <img src={BlueBgLogo} />
          </div>
        </div>
        <div className={classes.subContainer}>
          <Outlet />
        </div>
      </div>
    </main>
  );
};
export default AuthLayout;
